export default "__VITE_ASSET__fpRVzMDP__"